import { __decorate, __metadata } from "tslib";
import { LvValidator } from "../validator/LvValidator";
import { Component, Prop, Provide } from "vue-property-decorator";
/**
 * The orientation of the form
 */
export var LvFormOrientation;
(function (LvFormOrientation) {
    LvFormOrientation["Horizontal"] = "horizontal";
    LvFormOrientation["Vertical"] = "vertical";
})(LvFormOrientation || (LvFormOrientation = {}));
/**
 * Injection symbol provided by the LvForm component
 */
export const SYM_LV_FORM = Symbol("LvForm");
export const COMPONENT_NAME = "LvForm";
/**
 * A form component, providing model validation.
 */
let LvForm = class LvForm extends LvValidator {
    get self() {
        return this;
    }
    get classList() {
        return [
            "lv-form",
            this.orientation,
        ].filter(x => x != null);
    }
};
__decorate([
    Prop({ type: String, required: false, default: LvFormOrientation.Vertical }),
    __metadata("design:type", String)
], LvForm.prototype, "orientation", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvForm.prototype, "nativeForm", void 0);
__decorate([
    Provide(SYM_LV_FORM),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvForm.prototype, "self", null);
LvForm = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvForm);
export default LvForm;
//# sourceMappingURL=script.js.map